import instance from "@/services/api";

export const projectsOverviewAPI = {
  async getProjectsCommonInfo(params) {
    return await instance()
      .get("/project/common/info/read/", { params })
      .then((res) => res?.data);
  },
  async getResidentials() {
    return await instance()
      .get("/project/resident/read/")
      .then((res) => res?.data);
  },
  async getProjectTypes(params) {
    return await instance()
      .get("/project/project_types/read/", { params })
      .then((res) => res?.data);
  },
};
